'use client';

import React from 'react';
import './CustomSlider.scss';

export default function CustomSlider({ min, max, divisions, value, step, onChange }) {
  const percentage = ((value - min) / (max - min)) * 100;

  const sliderTrackStyle = {
    background: `linear-gradient(to right, rgba(18, 18, 18, 1) 0%, rgba(18, 18, 18, 1) ${percentage}%, rgba(235, 235, 235, 1) ${percentage}%, rgba(235, 235, 235, 1) 100%)`,
  };

  const handleChange = (e) => {
    onChange(Number(e.target.value));
  };

  return (
    <div className={'CustomSlider'}>
      <div className={'sliderContainer'}>
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          className={'slider'}
          style={sliderTrackStyle}
          step={step}
        />

        <ul className={'divisions'}>
          {Array.from({ length: divisions }).map((_, index) => (
            <li key={index} className={'divisions_item'} style={{}} />
          ))}
        </ul>
        <div className={'labelContainer'}>
          <span>{min}</span>
          <span>{max}</span>
        </div>
      </div>
    </div>
  );
}
